module.exports = __webpack_public_path__ + "img/26_174.7253ad03.png";